<template>
  <div class="contact-box">
   <van-nav-bar
   :title="title"
   left-text="返回"
   left-arrow
   @click-left="onClickLeft"/>
  </div>
</template>

  <script>
  import { NavBar,Icon,Row, Col,DropdownMenu,DropdownItem} from 'vant';
  export default {
    props: ["title","pathName"],
    data() {
      return {};
      title:"";
    },
    components: {
      [NavBar.name]: NavBar,
      [Icon.name]: Icon,
      [Row.name]: Row,
      [Col.name]: Col,
      [DropdownMenu.name]: DropdownMenu,
      [DropdownItem.name]: DropdownItem,
    },
    
    methods: {
    go(pathName) {
      this.$router.push({ name: pathName });
    },
    onClickLeft() {
      if(this.pathName) {
         this.go(this.pathName)
      }else{
        this.$router.go(-1);
      }
    },
    }
  };
  </script>

  <style lang="less" scoped>
   .van-nav-bar{ background:#378be1; border-bottom:none; height: 55px; line-height: 55px;}
   .van-nav-bar__title,.van-nav-bar__text{ color:#fff !important;}
   /deep/.van-dropdown-menu{ background:none;}
   /deep/.van-dropdown-menu__title{ color:#fff!important;}
   /deep/.van-dropdown-menu__title::after{ display:none;}
   .sign_out{ color:#fff;}
   /deep/.van-nav-bar .van-icon{
  color: #fff;
}
  </style>